import React from 'react';

function CloseSVG() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.949631 0.636033C1.34016 0.245509 1.97332 0.245509 2.36384 0.636033L7.31359 5.58578L12.2633 0.636033C12.6539 0.245508 13.287 0.245509 13.6776 0.636033C14.0681 1.02656 14.0681 1.65972 13.6776 2.05025L8.72781 6.99999L13.6776 11.9497C14.0681 12.3403 14.0681 12.9734 13.6776 13.364C13.287 13.7545 12.6539 13.7545 12.2633 13.364L7.31359 8.41421L2.36384 13.364C1.97332 13.7545 1.34016 13.7545 0.949631 13.364C0.559107 12.9734 0.559107 12.3403 0.949631 11.9497L5.89938 6.99999L0.949631 2.05025C0.559107 1.65972 0.559107 1.02656 0.949631 0.636033Z"
      />
    </svg>
  );
}

export default CloseSVG;
